import type theme from '#build/ui/chip'
import type { DeepPartial } from '@nuxt/ui'

const chip: DeepPartial<typeof theme> = {
  slots: {
    root: 'relative inline-flex shrink-0 items-center justify-center',
    base: 'shadow-xs flex items-center justify-center whitespace-nowrap rounded-full font-medium ring ring-transparent text-transparent',
  },
  variants: {
    color: {
      info: 'bg-cvt-info-border text-cvt-info-bg shadow-cvt-info-border ring-cvt-info-bg',
      warning: 'bg-cvt-warning-border text-cvt-warning-bg shadow-cvt-warning-border ring-cvt-warning-bg',
      error: 'bg-cvt-error-border text-cvt-error-bg shadow-cvt-error-border ring-cvt-error-bg',
      success: 'bg-cvt-success-border text-cvt-success-bg shadow-cvt-success-border ring-cvt-success-bg',
    },
    size: {
      '3xs': 'h-[4px] min-w-[4px] text-[4px]',
      '2xs': 'h-[6px] min-w-[6px] text-[6px]',
      'xs': 'h-[8px] min-w-[8px] text-[8px]',
      'sm': 'h-[10px] min-w-[10px] text-[10px]',
      'md': 'h-[12px] min-w-[12px] text-xs',
      'lg': 'h-[14px] min-w-[14px] text-xs',
      'xl': 'h-[16px] min-w-[16px] text-xs',
      '2xl': 'h-[18px] min-w-[18px] text-sm',
      '3xl': 'h-[20px] min-w-[20px] text-base',
    },
    position: {
      'top-right': 'right-0 top-0',
      'bottom-right': 'bottom-0 right-0',
      'top-left': 'left-0 top-0',
      'bottom-left': 'bottom-0 left-0',
    },
  },
  defaultVariants: {
    size: 'md',
    color: 'info',
    position: 'top-right',
  },
}

export default chip
